<div class="row" *ngIf="form as form" [formGroup]="form">
  <div class='col-md-4'>
    <div class='form-group' *ngIf='"pesel" as controlName'>
      <label [for]='controlName'>
        Numer PESEL *
      </label>
      <input
        mask="00000000000"
        [id]='controlName'
        [formControlName]='controlName'
        [ngClass]='{ "is-invalid": form.showError(controlName) }'
        placeholder='Wpisz tu numer PESEL'
        type='text'>
      <app-validation-errors [control]='form.get(controlName)'>
      </app-validation-errors>
    </div>
  </div>
  <div class='col-md-4'>
    <div class='form-group' *ngIf='"firstName" as controlName'>
      <label [for]='controlName'>
        Imię/Imiona *
      </label>
      <input
        [id]='controlName'
        [ngClass]='{ "is-invalid": form.showError(controlName) }'
        [formControlName]='controlName'
        placeholder='Wpisz tu imię/imiona'
        type='text'>
      <app-validation-errors [control]='form.get(controlName)'>
      </app-validation-errors>
    </div>
  </div>
  <div class='col-md-4'>
    <div class='form-group' *ngIf='"lastName" as controlName'>
      <label [for]='controlName'>
        Nazwisko *
      </label>
      <input
        [id]='controlName'
        [formControlName]='controlName'
        [ngClass]='{ "is-invalid": form.showError(controlName) }'
        placeholder='Wpisz tu nazwisko'
        type='text'>
      <app-validation-errors [control]='form.get(controlName)'>
      </app-validation-errors>
    </div>
  </div>
  <div class='col-md-4'>
    <div class='form-group' *ngIf='"regon" as controlName'>
      <label [for]='controlName'>
        REGON
      </label>
      <input
        [id]='controlName'
        [formControlName]='controlName'
        [ngClass]='{ "is-invalid": form.showError(controlName) }'
        placeholder='Wpisz tu REGON'
        type='text'>
      <app-validation-errors [control]='form.get(controlName)'>
      </app-validation-errors>
    </div>
  </div>
</div>
